export default __webpack_public_path__ + "static/media/Ocean tide 1.4f2d2650.jpg";